export const DEFAULT_PARAMS = {
    Prompt: { prompt: '' },
    OpenQuestion: {
        question: '',
        acknowledgment_prompt: '',
    },
    YesNoConfirmation: {
        question: '',
        prompt_yes_acknowledgment: '',
        prompt_no_acknowledgment: '',
        yes_alternatives: '',
        no_alternatives: '',
        number_of_retries: 2,
        prompt_fallback: '',
        escape_mode: 'undefined',
    },
    GPTModule: {
        question: '',
        prompt_yes_acknowledgment: '',
        prompt_no_acknowledgment: '',
        yes_alternatives: '',
        no_alternatives: '',
        number_of_retries: 2,
        prompt_fallback: '',
        escape_mode: 'undefined',
    },
    NumericRatingModule: {
        min: 0,
        max: 0,
        retries: 0,
        prompt: '',
        out_of_bounds_prompt: '',
        not_found_prompt: '',
        found_prompt: '',
        try_again_prompt: '',
        max_retries_reached_prompt: '',
    },
    ValueRangeRouter: {
        value: '',
        min_value: undefined,
        max_value: undefined,
        interval_partition_points: [],
    },
    CalendarModule: {
        path: 'mama_bots.bots.calendar_bot.calendar_module',
        project: 'maddie',
    },
    StickerModule: {
        stickers: ['S1'],
    },
    MSearchModule: {
        collection_id: '',
        search_mode: 'hybrid',
        ggr_provider: {},
        ggr_llm_config: {
            provider: 'azure',
            service: 'llm1-themamaai',
            engine: 'gpt35turbo',
        },
        mapping: {},
    },
    MDataChatModule: {
        project_id: '',
        username: '',
        password: '',
    },
    RestCallout: {
        request_template: {
            method: 'GET',
            base_url: 'https://domain.com',
            endpoint: '/endpoint',
        },
    },
    SMSModule: {
        prompt: '',
        isCustomPhone: false,
    },
    TransferToAgentModule: {
        transfer_number: '',
        check_agent_availability: false,
        allow_leaving_message: false,
    },
} as const;
